/* COPYRIGHT Esri - https://js.arcgis.com/5.1/LICENSE.txt */
import { safeClassMap } from "@arcgis/lumina";
import { nothing, html } from "lit";
import { ref } from "lit/directives/ref.js";
const CSS = {
  container: "clear-button--container"
};
const clearButtonReference = () => {
  return;
};
const ClearButton = ({ ariaLabel, ref: ref$1, disabled, focusable, onClick, scale, title }) => {
  return html`<div class=${safeClassMap(CSS.container)} .inert=${disabled} ${ref(ref$1 ? ref$1 : clearButtonReference)}><calcite-action .disabled=${disabled} icon=x .label=${ariaLabel} @click=${onClick} .scale=${scale} tabindex=${(focusable ? void 0 : -1) ?? nothing} .text=${title} title=${title ?? nothing}></calcite-action></div>`;
};
export {
  ClearButton as C
};
